export default __webpack_public_path__ + "static/media/fb-white.ee09ada4.svg";